module.exports = __webpack_public_path__ + "img/ico-pressure-high-p.f203d3a9.png";